import axiosInstance from "./axios-service/axiosInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
};

const candidateSkillSetsService = {
  fetchAllCandidateSkillSets: () => {
    return axiosInstance.get(
      `/itl_candidateskillsetses?$select=itl_candidateskillsetsid,_itl_candidateid_value,createdon,itl_skillname,_itl_skillset_value&$expand=itl_SkillSet($select=itl_skillsetmasterid,itl_name)&$orderby=createdon desc`,
      {
        headers: headers,
      }
    );
  },

  fetchCandidateSkillSets: (id) => {
    return axiosInstance.get(
      `/itl_candidateskillsetses?$select=itl_candidateskillsetsid,_itl_candidateid_value,itl_experiencerange,itl_experience,itl_skillname,_itl_skillset_value&$expand=itl_SkillSet($select=itl_skillsetmasterid,itl_name)&$filter=_itl_candidateid_value eq ${id}`,
      {
        headers: headers,
      }
    );
  },

  addCandidateSkillSkillSet: (obj) => {
    return axiosInstance.post("/itl_candidateskillsetses", obj);
  },

  updateCandidateSkillSkillSet: (id, obj) => {
    return axiosInstance.patch(`/itl_candidateskillsetses(${id})`, obj);
  },
  deleteCandidateSkillSkillSet: (id) => {
    return axiosInstance.delete(`/itl_candidateskillsetses(${id})`);
  },
};

export default candidateSkillSetsService;
